import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.orderBy = 'CreationTime';
    serverTableData.ascending = false;
  }
  if (serverTableData.orderBy === 'agence') serverTableData.orderBy = 'agenceId';
  if (serverTableData.query?.periodeContrats
    && !serverTableData.query.periodeContrats.dateDebut
    && !serverTableData.query.periodeContrats.dateFin) {
    delete serverTableData.query.periodeContrats;
  }
  if (serverTableData.query?.datePreavis
    && !serverTableData.query.datePreavis.dateDebut
    && !serverTableData.query.datePreavis.dateFin) {
    delete serverTableData.query.datePreavis;
  }
  if (serverTableData.orderBy === 'indexation') serverTableData.orderBy = 'estIndexe';
  return generalTransformer(serverTableData);
}
